/* eslint-disable import/prefer-default-export */
import { marketingAssetsService, marketingScriptsService } from 'config/api';
import { uuidv4 } from 'utils/commonUtils';
import actionTypes from './actionTypes';

export const getMarketingAssets = (parameters = {}, type = 'all') => async (dispatch) => {
  dispatch({ type: actionTypes.MARKETING_ASSETS_LOADING });

  const typesMap = {
    all: actionTypes.GET_MARKETING_ASSETS_SUCCESS,
    search: actionTypes.SEARCH_MARKETING_ASSETS_SUCCESS,
  };

  try {
    const { data } = await marketingAssetsService.post('', parameters);
    dispatch({
      type: typesMap[type],
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.MARKETING_ASSETS_ERROR,
      payload: error,
    });
  }
};

export const getMarketingScripts = (parameters = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.MARKETING_SCRIPTS_LOADING });

  try {
    const { data } = await marketingScriptsService.post('', parameters);
    dispatch({
      type: actionTypes.GET_MARKETING_SCRIPTS_SUCCESS,
      payload: {
        ...data,
        subFolder: parameters.subFolder,
      },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.MARKETING_SCRIPTS_ERROR,
      payload: error,
    });
  }
};

export const newSearchMarketingAssets = (parameters = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.MARKETING_ASSETS_LOADING });

  try {
    const { data } = await marketingAssetsService.post('', parameters);
    dispatch({
      type: actionTypes.NEW_SEARCH_MARKETING_ASSETS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.MARKETING_ASSETS_ERROR,
      payload: error,
    });
  }
};

export const addMarketingAssets = (assets = []) => async (dispatch) => {
  const checkedAssets = assets.map((item) => ({ id: uuidv4(), item }));

  dispatch({
    type: actionTypes.ADD_MARKETING_ASSETS,
    payload: checkedAssets,
  });
};

export const resetMarketingAssets = (type = 'all') => (dispatch) => {
  const typesMap = {
    all: actionTypes.RESET_MARKETING_ASSETS,
    search: actionTypes.RESET_SEARCH_MARKETING_ASSETS,
  };

  dispatch({ type: typesMap[type] });
};
